<template>
  <div class="w-full flex mb-[32px] lg:mb-[48px]" :class="outerPositionClass">
    <div class="flex flex-col" :class="innerPositionClass">
      <span
        v-if="pin"
        class="text-xs tracking-widest xl:text-base font-medium w-full font-saira mb-1"
        :class="titleColorClass"
        :style="titleColorStyle"
        v-html="pin"
      ></span>
      <h2
        v-if="title"
        class="text-3xl xl:text-[38px] xl:leading-[48px] font-semibold w-full md:w-[500px] lg:w-[800px] xl:w-[1024px]  font-saira"
        :class="titleColorClass"
        :style="titleColorStyle"
        v-html="title"
      ></h2>
      <p
        v-if="description"
        class="text-base xl:text-lg w-full md:w-[500px] lg:w-[650px] xl:w-[850px] mt-2"
        :class="titleColorClass"
        :style="titleColorStyle"
        v-html="description"
      ></p>
      <AtomsButton
        v-if="button?.enabled"
        :label="button?.label"
        :link="button?.link"
        size="medium"
        :color="button?.color"
        :disabled="button?.disabled"
        class="mt-4 !font-bold"
      />
    </div>
  </div>
</template>
<script setup>
const outerPositionClass = computed(() => {
  if (props.position === "left") return "justify-start";
  if (props.position === "right") return "justify-end";
  return "justify-center px-[16px] lg:px-[32px]";
});

const innerPositionClass = computed(() => {
  const result = [];
  if (props.position === "left") result.push("text-left items-start");
  else if (props.position === "right") result.push("text-right items-end");
  else result.push("text-center items-center");
  return result;
});

const titleColorClass = computed(() => {
  if (props.color?.startsWith("#")) return "";
  if (props.color === "white") return "text-white";
  if (props.color === "first") return "text-brand-first";
  if (props.color === "second") return "text-brand-second";
  return "text-black";
});

const titleColorStyle = computed(() => {
  if (props.color?.startsWith("#")) return { color: props.color };
  return {};
});

const props = defineProps({
  pin: { type: String },
  title: {
    type: String,
  },
  description: {
    type: String,
  },
  button: {
    type: Object,
  },
  color: {
    type: String,
    default: "first",
  },
  position: {
    type: String,
  },
});
</script>
